import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useFieldFormContext } from "@/features/question/components/organisms/FieldForm";

// TODO lacks dateFormat
export function DateForm() {
    const { isFormDisabled, form } = useFieldFormContext();

    return (
        <div className="flex flex-col gap-2">
            <FormField
                name="field_date_options.timezone"
                control={form.control}
                render={({ field }) => (
                    <FormItem>
                        <FormLabel>
                            Time Zone
                        </FormLabel>
                        <FormControl>
                            <Input
                                {...field}
                                disabled={isFormDisabled}
                                autoComplete="off"
                            />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />
            <FormField
                name="field_date_options.timeFormat"
                control={form.control}
                render={({ field }) => (
                    <FormItem>
                        <FormLabel>
                            Time Format
                        </FormLabel>
                        <Select onValueChange={field.onChange} value={field.value} disabled={isFormDisabled}>
                            <FormControl>
                                <SelectTrigger autoComplete="off">
                                    <SelectValue placeholder="Select time format" />
                                </SelectTrigger>
                            </FormControl>
                            <SelectContent>
                                <SelectItem value="h:mma">12 Hour</SelectItem>
                                <SelectItem value="HH:mm">24 Hour</SelectItem>
                            </SelectContent>
                        </Select>
                        <FormMessage />
                    </FormItem>
                )}
            />
        </div>
    );
}